import React, { useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  Box,
  Divider,
  Snackbar,
  Alert,
} from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import Header from "./Header";

const CustomerSupport = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      setToast({
        open: true,
        message: "❗ Please fill all required fields.",
        severity: "warning",
      });
      return;
    }

    try {
      const res = await fetch("https://sakhisshop.com/api/support/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Failed to submit");

      setToast({
        open: true,
        message: "✅ Request submitted successfully!",
        severity: "success",
      });
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setToast({
        open: true,
        message: "❌ Failed to submit request.",
        severity: "error",
      });
      console.error("Error:", error);
    }
  };

  return (
    <Container sx={{ mt: 5, mb: 5, py: 3 }}>
      <Header />

      <Typography variant="h4" align="center" fontWeight={600} mb={4}>
        🛎️ Customer Support
      </Typography>

      {/* Contact Info */}
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ minHeight: 180 }}>
            <CardContent sx={{ textAlign: "center" }}>
              <PhoneIcon color="primary" fontSize="large" />
              <Typography variant="h6" mt={2}>
                Call Us
              </Typography>
              <Typography variant="body2" color="text.secondary">
                +91 9595***8585 <br /> Mon-Sat: 9:00AM - 6:00PM
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ minHeight: 180 }}>
            <CardContent sx={{ textAlign: "center" }}>
              <EmailIcon color="primary" fontSize="large" />
              <Typography variant="h6" mt={2}>
                Email Support
              </Typography>
              <Typography variant="body2" color="text.secondary">
                support@sakhisshop.com
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Divider */}
      <Box my={5}>
        <Divider />
      </Box>

      {/* Support Form */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        autoComplete="off"
        sx={{ backgroundColor: "#f9f9f9", p: 4, borderRadius: 3, boxShadow: 2 }}
      >
        <Typography variant="h5" mb={3} fontWeight={500}>
          📬 Submit a Request
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Your Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email Address"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Subject"
              name="subject"
              value={form.subject}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Message"
              name="message"
              multiline
              rows={4}
              value={form.message}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Box textAlign="center">
              <Button
                variant="contained"
                size="large"
                type="submit"
                sx={{ px: 5, py: 1.2 }}
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Toast Snackbar */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={toast.severity}
          variant="filled"
          onClose={() => setToast({ ...toast, open: false })}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CustomerSupport;
